const delivery = (state = null, action) => {
    switch(action.type) {
        case 'delivery':
            return action.payload;
        default:
            return state;
    }
}

export default delivery;